export const ACCOUNT_PATH = '/account';
export const AML_PATH = '/aml';
